import { GridColDef } from '@mui/x-data-grid';
import * as yup from 'yup';

const columns: GridColDef[] = [
  { field: 'name', headerName: 'Hashtags', flex: 1 }
];

const schema = yup.object({
  name: yup.string().trim().required('Hashtag is required')
});

const parseValidationErrors = (error: any): Record<string, string> => {
  if (error.name !== 'ValidationError') return {};

  const fieldErrors: Record<string, string> = {};
  error.inner.forEach((err: any) => {
    if (err.path) fieldErrors[err.path] = err.message;
  });

  return fieldErrors;
};

export { columns, schema, parseValidationErrors };
